import queries from '@apis/queries';
import Accordion from '@components/Accordion';
import Row from '@components/Row';
import Text from '@components/Text';
import { css } from '@emotion/react';
import { Link } from '@router/Link';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

function OrderTermNotes() {
    const { t } = useTranslation('order');
    const { data } = useQuery(queries.termCategories.list('ORDER'));
    if (data?.categories && data.categories.length !== 0) {
        return (
            <Accordion title={
                <Text fontWeight='bold' size='lg'>
                    {t('termNotes.title')}
                </Text> }>
                {data?.categories.map((category) => (
                    <Link activityName='TermDetailActivity'
                        activityParams={{ termCategoryId: category.id }}>
                        <Row key={category.id} css={css`padding: 8px 0;`}
                            fullWidth justify='space-between' >
                            <Text size='lg'>{category.title}</Text>
                            <Text fontWeight='bold' css={css`text-decoration: underline;`}>
                                {t('termNotes.viewDetail')}
                            </Text>
                        </Row>
                    </Link>
                ))}
            </Accordion>
        );
    }
    return null;
}

export default OrderTermNotes;
